import React from 'react'
import classnames from 'classnames'
import { compose, setPropTypes, defaultProps } from 'recompose'
import PropTypes from 'prop-types'

import { InputContainer } from './styled'

import TextInput from './TextInput'
import TextSearch from './TextSearch'
import DateInput from './DateInput'
import DateTimeInput from './DateTimeInput'
import TimeInput from './TimeInput'
import NumberInput from './NumberInput'
import SelectInput from './SelectInput'
import TextAreaInput from './TextAreaInput'
import PasswordInput from './PasswordInput'
// import RadioInput from './RadioInput'
import CheckboxInput from './CheckboxInput'
// import TagInput from './TagInput'
import FileInput from './FileInput'
import TabSelectionInput from './TabSelectionInput'
import SwitchInput from './SwitchInput'
import MultiSelectInput from './MultiSelectInput'
import RadioInput from './RadioInput'
import LabelOnly from './LabelOnly'
import SelectInputWithStampNull from './SelectInputWithStampNull'

export const InputType = {
  text: 'text',
  textSearch: 'textSearch',
  textArea: 'textArea',
  date: 'date',
  dateTime: 'dateTime',
  time: 'time',
  number: 'number',
  select: 'select',
  password: 'password',
  radio: 'radioOpt',
  checkbox: 'checkbox',
  tag: 'tag',
  file: 'file',
  tabSelection: 'tabSelection',
  switch: 'switch',
  multiSelect: 'multiSelect',
  empty: 'empty',
  labelOnly: 'labelOnly',
  selectwithnull: 'selectwithnull'
}

const FieldInput = (props) => {
  const { containerStyle } = props
  return (
    <InputContainer style={{ ...containerStyle }} className={classnames({fileInput: props.type === InputType.file}, props.className)}>
      {
        (() => {
          switch(props.type) {
            case InputType.text:
              return <TextInput {...props} />
            case InputType.textSearch:
              return <TextSearch {...props} />
            case InputType.date:
              return <DateInput {...props} />
            case InputType.dateTime:
              return <DateTimeInput {...props} />
            case InputType.time:
                return <TimeInput {...props} />
            case InputType.number:
              return <NumberInput {...props} />
            case InputType.select:
              return <SelectInput {...props} />
            case InputType.textArea:
              return <TextAreaInput {...props} />
            case InputType.password:
              return <PasswordInput {...props} />
            case InputType.radio:
              return <RadioInput {...props} />
            case InputType.checkbox:
              return <CheckboxInput {...props} />
            // case InputType.tag:
            //   return <TagInput {...props} />
            case InputType.file:
              return <FileInput {...props} />
            case InputType.tabSelection:
              return <TabSelectionInput {...props} />
            case InputType.switch:
              return <SwitchInput {...props} />
            case InputType.multiSelect:
              return <MultiSelectInput {...props} />
            case InputType.labelOnly:
              return <LabelOnly {...props} />
            case InputType.selectwithnull:
              return <SelectInputWithStampNull {...props} />
            case InputType.empty:
              return null
            default: 
              return <TextInput {...props} />
          }
        })()
      }
    </InputContainer>
  )
}

const propTypes = {
  type: PropTypes.oneOf(Object.keys(InputType))
}

const defaultProp = {
  type: InputType.text
}

export default compose(
  setPropTypes(propTypes),
  defaultProps(defaultProp)
)(FieldInput)
